import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';

import { usePackagesContext } from 'leash/context/packages/PackagesContext';
import { LeashRoutes } from 'leash/utilities/const';
import { NavigationMenuStyled } from './NavigationMenu.styles';

function NavigationMenu() {
  const [selectedMenuKey, setSelectedMenuKey] = useState('');
  const { pathname } = useLocation();
  const { dispatch } = usePackagesContext();

  useEffect(() => {
    setSelectedMenuKey(pathname);
    if (pathname === LeashRoutes.Packages) {
      dispatch({ type: 'SET_FETCH_PACKAGES' });
    }
  }, [pathname]);

  return (
    <NavigationMenuStyled mode="horizontal" selectedKeys={[selectedMenuKey]}>
      <Menu.Item key={LeashRoutes.Packages}>
        <Link to={LeashRoutes.Packages}>Travel Planning</Link>
      </Menu.Item>
      <Menu.Item key={LeashRoutes.Archived}>
        <Link to={LeashRoutes.Archived}>Archived</Link>
      </Menu.Item>
    </NavigationMenuStyled>
  );
}

export default NavigationMenu;
